import React, { useState } from "react";
import { Dropdown, DropdownButton } from "react-bootstrap";
import { ToolTip } from "../../../../ProPlans/PlanCards";
import { hasFeature } from "../../../../../utils/general";
import {F_EMAIL_GATE, F_PWD_PROTECTION} from "../../../../../constants/plans/constants";

const DISPLAY_MODE_STANDARD = 'No restrictions (public)';
export const DISPLAY_MODE_PASSWORD = 'Password protected';
export const DISPLAY_MODE_EMAIL_GATE = 'Capture emails';

const MODES = {
  [DISPLAY_MODE_STANDARD]: {
    "icon": "rectangle.svg",
    "desc": "No restrictions for your visitors"
  },
  [DISPLAY_MODE_PASSWORD]: {
    "icon": "lock-black.svg",
    "desc": "Make your link private by adding a layer of security"
  },
  [DISPLAY_MODE_EMAIL_GATE]: {
    "icon": "mail.svg",
    "desc": "Capture potential leads by requiring visitors to enter their email address"
  },
}

const SelectItem = ({ label, trial }) =>
  (<Dropdown.Item
    className="flex pt-2 pb-2"
    eventKey={label}
    style={{ whiteSpace: 'wrap' }}
    disabled={trial}
  >
    <img className={`me-3 mt-1 ${trial ? 'opacity-25' : 'opacity-75'}`} src={`assets/icons/${MODES[label].icon}`} height={20}/>
    <div>
      <div>
        {label}
        {trial && <img className="ms-1 opacity-50 op" alt="Pro" src="assets/icons/pro-black.png" height="20"/>}
      </div>
      <div className="font-small grey">{MODES[label].desc}</div>
    </div>
</Dropdown.Item>)

const DisplayModeSelect = ({ visible, onSelect, initialValue = DISPLAY_MODE_STANDARD, productId }) => {
  if (!visible)
    return null;

  const [selected, setSelected] = useState(initialValue)

  const onChange = (e) => {
    setSelected(e)
    onSelect(e)
  }

  return <div className="align-items-center w-100 ps-3 pe-3 pb-3">
    <div className="light-grey flex-grow-1">
      Access gate
      <ToolTip text="Choose how your content is restricted for visitors" />
    </div>
      <DropdownButton
        className="d-grid bg-light-grey round-8 mt-3 ms-2 me-2 mb-0 text-start"
        title={<span className="d-inline-flex" style={{ width: '95%' }}>
          <img className="pt-1 me-2 op-6" src={`assets/icons/${MODES[selected].icon}`} height={22}/>
          {selected}
        </span>}
        onSelect={onChange}
        variant="outline"
      >
        <SelectItem label={DISPLAY_MODE_STANDARD} />
        <SelectItem label={DISPLAY_MODE_PASSWORD} trial={!hasFeature(productId, F_PWD_PROTECTION)} />
        <SelectItem label={DISPLAY_MODE_EMAIL_GATE} trial={!hasFeature(productId, F_EMAIL_GATE)} />
      </DropdownButton>
  </div>
}

export default DisplayModeSelect;